import ComparisonBenchmark from '@/types/comparison-benchmark';
import { AsyncResult, Action, ApiAction } from '../../index';
import api from '../../redux-api';

// Types
import { SavedBenchmarksState } from '../types/saved-benchmarks';

// Initial State
const INITIAL_STATE: SavedBenchmarksState = {
  benchmarks: [],
  loading: false,
};

// Actions
const MY_BENCHMARKS_GET_ALL: ApiAction = {
  type: 'connect/benchmarks/saved-benchmarks/get-all',
  endpoint: 'users/my-benchmarks',
};

const MY_BENCHMARKS_ADD: ApiAction = {
  type: 'connect/benchmarks/saved-benchmarks/add',
  endpoint: 'users/my-benchmarks',
};

const MY_BENCHMARKS_DELETE: ApiAction = {
  type: 'connect/benchmarks/saved-benchmarks/delete',
  endpoint: 'users/my-benchmarks/:id/',
};

// Reducer
export default function reducer(state: SavedBenchmarksState = INITIAL_STATE, action: Action): SavedBenchmarksState {
  switch (action.type) {
    case MY_BENCHMARKS_GET_ALL.type: {
      return {
        ...state,
        benchmarks: [],
        loading: true,
      };
    }
    case `${MY_BENCHMARKS_GET_ALL.type}_SUCCESS`: {
      return {
        ...state,
        benchmarks: action.data.data || [],
        loading: false,
      };
    }
    case `${MY_BENCHMARKS_GET_ALL.type}_ERROR`: {
      return {
        ...state,
        loading: false,
      };
    }
    case MY_BENCHMARKS_ADD.type:
      return {
        ...state,
        benchmarks: [...state.benchmarks, ...action.payload.benchmarks],
      };
    case `${MY_BENCHMARKS_ADD.type}_ERROR`:
      return {
        ...state,
        benchmarks: state.benchmarks.filter(f => !action.payload.benchmarks.includes(f._id)),
      };
    case MY_BENCHMARKS_DELETE.type:
      return {
        ...state,
        benchmarks: state.benchmarks.filter(f => f._id !== action.id),
      };
    default:
      return state;
  }
}

// Action Creators
export const getSavedBenchmarks = (): AsyncResult<ComparisonBenchmark[]> => () => api.get(MY_BENCHMARKS_GET_ALL).then((res: { data: any }) => res.data);

export const toggleSavedBenchmark =
  (benchmark: ComparisonBenchmark): AsyncResult<ComparisonBenchmark[]> =>
  (dispatch, getState) => {
    const savedBenchmarks = getState().comparisonBenchmarks.savedBenchmarks.benchmarks;

    if (savedBenchmarks.some(b => b._id === benchmark._id)) {
      return api.delete(MY_BENCHMARKS_DELETE, { id: benchmark._id }).catch((response: { status: any }) => {
        // Add benchmark back to the state if there was an unhandled error
        // 404 means it's already out of the user's saved benchmarks, so don't re-add it
        if (response.status !== 404) {
          dispatch({ type: MY_BENCHMARKS_ADD.type, payload: { benchmarks: [benchmark] } });
        }

        throw response;
      });
    }

    return api.post(MY_BENCHMARKS_ADD, {}, { benchmarks: [benchmark] });
  };
